import React, { Component } from "react"
import { Link } from "gatsby"
import Image from "gatsby-image"
import CloudinaryVideo from "./cloudinaryvideo"

class HoverBullet extends Component {
  constructor(props) {
    super(props)
    this.mediaItem = React.createRef()
    this.hoverPlayVideo = this.hoverPlayVideo.bind(this)
    this.hoverPauseVideo = this.hoverPauseVideo.bind(this)
  }
  hoverPlayVideo() {
    if (this.props.bullet.hoverType == "video") {
      this.mediaItem.current.playVideo()
    } else {
      return false
    }
  }
  hoverPauseVideo() {
    if (this.props.bullet.hoverType == "video") {
      this.mediaItem.current.pauseVideo()
    } else {
      return false
    }
  }
  render() {
    const bullet = this.props.bullet
    const num = this.props.num
    return (
      <div
        onMouseEnter={() => this.hoverPlayVideo()}
        className="bullet-item block text-mobmd desk:text-lg my-10"
      >
        <span className="block opacity-30 hover:opacity-100">
          {num} - {bullet.title}
        </span>
        {bullet.hoverType == "video" ? (
          <div className="asset transition-opacity">
            {bullet.video ? (
              <CloudinaryVideo
                publicUrl={bullet.video}
                autoPlay={false}
                ref={this.mediaItem}
              />
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        {bullet.hoverType == "image" ? (
          <div className="asset transition-opacity">
            <Image
              fluid={bullet.image?.localFile?.childImageSharp?.fluid}
              eager={true}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    )
  }
}

export default HoverBullet

// return (
//   <div className="relative" onMouseEnter={() => this.hoverPlayVideo()}>
//     <p className="text-lg">{index} {bullet.title}</p>
//     {
//       (bullet.hoverType === "video" && bullet?.video?.mediaItemUrl) ?
//         <CloudinaryVideo
//           publicUrl={bullet.video.mediaItemUrl}
//           autoPlay={false}
//         />
//       : ''
//     }
//     {
//       (bullet.hoverType === "image" && bullet.image?.localFile?.childImageSharp?.fluid) ?
//         <Image
//           fluid={bullet.image?.localFile?.childImageSharp?.fluid}
//         />
//       : ''
//     }
//   </div>
// )
